function generateTag(price, salePrice) {
  if (
    price !== undefined &&
    salePrice !== undefined &&
    salePrice >= 0 &&
    salePrice < price
  ) {
    const discount = Math.floor((1 - salePrice / price) * 100)
    return `${discount}% OFF`
  }

  return undefined
}

export default generateTag
